// This component is scoped out of CSS Editing for now, will be added in the future
const semanticClassNames = {
  root: 'date-picker',
  input: 'date-picker__input',
  icon: 'date-picker__icon',
  header: 'date-picker__header',
  label: 'date-picker__label',
  calendar: 'date-picker__calendar',
} as const;

export default semanticClassNames;
